import { useState, useEffect, useContext } from 'react'
import { Grid, Typography, Box, TextField } from '@material-ui/core'
import QuestionDescription from '../SharedComponent/QuestionDescription'
import MultipleChoiceOption from './components/MultipleChoiceOption'
import OptionBuilder from './components/OptionBuilder'
import { v4 as uuidv4 } from 'uuid'
import { NewQuestionContext, QuestionItemContext } from 'containers/Examination/ExaminationContext'

import './MultipleMultimedia.css'

const MultipleMultimedia = (props) => {
  const { onChange } = props
  const questionItem = useContext(QuestionItemContext)

  const [options, setOptions] = useState([])

  const addOption = (text, img) => {
    const uuid = uuidv4()
    let option = {
      id: uuid,
      text: text,
      img: '',
      img_id: null
    }

    if (img !== null) {
      option.img = img.photo_url
      option.img_id = img.id
    }

    setOptions((prevOptions) => [...prevOptions, option])
  }

  const [answerKey, setAnswerKey] = useState(null)
  const selectCorrectAnswer = (key) => {
    setAnswerKey(key)
  }

  const [description, setDescription] = useState(null)
  const [images, setImages] = useState(null)
  const addDescription = (description, imgs) => {
    setDescription(description)
    setImages(imgs)
  }

  const removeOption = (id) => {
    let updatedOption = options.filter((option) => {
      return option.id !== id
    })

    if (answerKey === id) {
      setAnswerKey(null)
    }

    setOptions(updatedOption)
  }

  const [pts, setPts] = useState(1)
  const handlePtsInput = (e) => {
    setPts(e.target.value)
  }

  useEffect(() => {
    onChange({
      description,
      images,
      options,
      answerKey,
      pts,
      type: 'MULTIPLE_CHOICES'
    })
  }, [options, images, description, answerKey, pts])

  useEffect(() => {
    if (questionItem !== undefined && questionItem !== null) {
      setOptions(questionItem.options)
      setAnswerKey(questionItem.answer)
      setPts(questionItem.pts)
    }
  }, [questionItem])

  return (
    <>
      <Grid container direction="column">
        <Grid item>
          <Typography variant="h6">Multiple Choices</Typography>
        </Grid>
        <Grid item>
          <NewQuestionContext.Provider value={{removeOption, options}}>
            <QuestionDescription onChange={addDescription} />

            <MultipleChoiceOption options={options} optionSelected={selectCorrectAnswer} correctAnswer={answerKey} />

            <OptionBuilder options={options} optionCreated={addOption} />

            <Box paddingTop={3}>
              <TextField
                type="number"
                label="Points"
                fullWidth
                defaultValue={pts}
                value={pts}
                onChange={handlePtsInput}
              />
            </Box>
          </NewQuestionContext.Provider>
        </Grid>
      </Grid>
    </>
  )
}

export default MultipleMultimedia